import { render, staticRenderFns } from "./WidgetTitle.vue?vue&type=template&id=00266cca&scoped=true"
import script from "./WidgetTitle.vue?vue&type=script&lang=js"
export * from "./WidgetTitle.vue?vue&type=script&lang=js"
import style0 from "./WidgetTitle.vue?vue&type=style&index=0&id=00266cca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00266cca",
  null
  
)

export default component.exports